import { QueryKey, useQuery, QueryResult, QueryConfig } from "react-query";
import { AxiosRequestConfig } from "axios";
import api from "../index";
import { IFeatureCost } from "types/payments/FeatureCost";

export const getFeatureCosts = async (
  options?: AxiosRequestConfig,
): Promise<IFeatureCost[]> => {
  const { data } = await api.get<IFeatureCost[]>(
    "/payments/feature-cost",
    options,
  );
  return data;
};

export const getFeatureCostsQueryKey = () => [`payments/feature-cost`];

export const useFeatureCosts = (options?: {
  query?: QueryConfig<IFeatureCost[], void>;
  request?: AxiosRequestConfig;
}): QueryResult<IFeatureCost[], void> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options || {};
  const queryKey = queryOptions?.queryKey ?? getFeatureCostsQueryKey();

  const queryFn = () => getFeatureCosts(requestOptions);

  const query = useQuery(queryKey, queryFn, {
    ...queryOptions,
    staleTime: 15 * 60 * 1000,
    cacheTime: 15 * 60 * 1000,
  });

  return {
    queryKey,
    ...query,
  };
};
